import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { listIssues } from '@mkcore/portal/schema';
import { Badge, EmptyState, Skeleton, TBody, THead, Table, Td, Th, Tr } from '@mkcore/ui';
import { call } from '@/lib/api';
import { formatDate } from '@/lib/format';

/** The issues MKC shows the client (CO-0665): title, state, milestone and when it changed; never the internal details. */
export const Route = createFileRoute('/portal/_client/issues')({
  component: Issues,
});

function Issues() {
  const { t } = useTranslation();
  const q = useQuery({ queryKey: ['portal', 'issues'], queryFn: () => call(listIssues, {}) });
  if (!q.data) return <Skeleton className="h-32" />;
  return (
    <>
      <h1 className="text-2xl font-bold">{t('portal.modules.issues')}</h1>
      {!q.data.items.length ? (
        <EmptyState title={t('portal.issueList.empty')} />
      ) : (
        <Table aria-label={t('portal.modules.issues')}>
          <THead>
            <Tr>
              <Th className="w-28">{t('portal.issueList.ref')}</Th>
              <Th>{t('portal.issueList.title')}</Th>
              <Th className="hidden sm:table-cell">{t('portal.issueList.milestone')}</Th>
              <Th>{t('portal.issueList.state')}</Th>
              <Th className="hidden sm:table-cell">{t('portal.issueList.updated')}</Th>
            </Tr>
          </THead>
          <TBody>
            {q.data.items.map((i) => (
              <Tr key={i.id}>
                <Td className="tabular text-fg-3">{i.ref}</Td>
                <Td className="font-bold">{i.title}</Td>
                <Td className="hidden sm:table-cell">{i.milestone ?? '–'}</Td>
                <Td>
                  <Badge tone={i.state === 'open' ? 'info' : 'success'}>{t(`portal.issueList.states.${i.state}`)}</Badge>
                </Td>
                <Td className="hidden tabular sm:table-cell">{formatDate(i.closedAt ?? i.updatedAt)}</Td>
              </Tr>
            ))}
          </TBody>
        </Table>
      )}
    </>
  );
}
